/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useProjectionsSite } from '../../contexts/SiteContext';
import RoundButton from '../buttons/RoundButton';

import styles from '../../../styles/menus/week.module.css';

const propTypes = {
    menu: PropTypes.arrayOf(PropTypes.shape({})),
    catalogUrl: PropTypes.string,
    className: PropTypes.string,
};

function WeekMenu({ menu = null, catalogUrl = null, className }) {
    const projections = useProjectionsSite();

    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={styles.left}>
                <div className={styles.buttons}>
                    <RoundButton href="/fr" className={styles.homeButton}>
                        <FormattedMessage defaultMessage="Home" description="Button label" />
                    </RoundButton>
                    {projections !== null ? (
                        <RoundButton
                            className={styles.button}
                            href={projections.url}
                            size="small"
                            external
                            target="_blank"
                        >
                            <FormattedMessage
                                defaultMessage="Projections Tënk"
                                description="Menu label"
                            />
                        </RoundButton>
                    ) : null}
                </div>
            </div>
            <div className={styles.right}>
                <div className={styles.buttons}>
                    {catalogUrl !== null ? (
                        <RoundButton
                            className={styles.button}
                            href={catalogUrl}
                            size="small"
                            external
                            target="_blank"
                        >
                            <FormattedMessage defaultMessage="Catalog" description="Menu label" />
                        </RoundButton>
                    ) : null}
                    {menu.map(({ label, url }, index) => (
                        <RoundButton
                            key={`${label}-${index + 1}`}
                            href={url}
                            className={styles.button}
                            size="small"
                        >
                            {label}
                        </RoundButton>
                    ))}
                </div>
            </div>
        </div>
    );
}

WeekMenu.propTypes = propTypes;

export default WeekMenu;
